import { Link } from 'react-router-dom';

const footerLinks = {
  '攻略分类': [
    { label: '玩法技巧', href: '/category?cat=wanfa-jiqiao' },
    { label: '关卡攻略', href: '/category?cat=guanka-gonglue' },
    { label: '高分秘籍', href: '/category?cat=gaofen-miji' },
    { label: '新手教程', href: '/category?cat=xinshou-jiaocheng' },
  ],
  '进阶内容': [
    { label: '进阶技巧', href: '/category?cat=jinjie-jiqiao' },
    { label: '隐藏要素', href: '/category?cat=yincang-yaosu' },
  ],
  '关于': [
    { label: '关于我们', href: '/about' },
    { label: '首页', href: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-100/50 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading text-primary-500">
              🍄 踩蘑菇攻略
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              最全面的踩蘑菇游戏攻略网站，提供玩法技巧、关卡攻略、高分秘籍和隐藏要素等丰富内容，助力每一位玩家成为蘑菇大师。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 踩蘑菇攻略大全。仅供学习交流，不涉及商业用途。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors duration-200" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}